var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('checkout-progress',{attrs:{"reservation":""}}),_c('personal-information',{attrs:{"reservation":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }